import type { LucideProps } from 'lucide-react';
import { icons as LucideIcons } from 'lucide-react';
import type { ComponentType } from 'react';

import { AtlasIcons } from '@crossnokaye/ux-animatics';

type ResolvedIconComponent = ComponentType<LucideProps>;

const resolveIconByName = (iconName?: string): ResolvedIconComponent | undefined => {
  if (!iconName) {
    return undefined;
  }

  const iconComponent = Object.hasOwn(AtlasIcons, iconName)
    ? AtlasIcons[iconName as keyof typeof AtlasIcons]
    : Object.hasOwn(LucideIcons, iconName)
      ? LucideIcons[iconName as keyof typeof LucideIcons]
      : undefined;

  return iconComponent as ResolvedIconComponent | undefined;
};

export const resolveIconComponent = ({
  fallbackIcon,
  icon,
}: {
  fallbackIcon?: string;
  icon: string;
}): ResolvedIconComponent | undefined => resolveIconByName(icon) ?? resolveIconByName(fallbackIcon);
